import type { IconProps } from './types';
import './icons.css';

export default function Send({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-send ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M2.292 17.708 17.708 10 2.292 2.292 5.417 10l-3.125 7.708ZM11.458 10H5.625"
      />
    </svg>
  );
}
